__turbopack_context__.v({
  "container": "styles-module__JKayna__container",
  "content": "styles-module__JKayna__content",
  "error": "styles-module__JKayna__error",
  "header": "styles-module__JKayna__header",
  "processing": "styles-module__JKayna__processing",
});
